export default "__VITE_ASSET__abf25247__"